import React from 'react';
import { PatternFormat } from 'react-number-format';
import FieldControl from './fieldControl';
import CustomTextInput from './customTextInput';

/**
* @param {Object} props
* @param {string} props.id
* @param {Object} props.error
* @param {string} props.error.message
* @param {boolean} props.disabled
* @param {boolean} props.isFocused
* @param {boolean} props.isVisible - If False Component Returns null
* @param {boolean} props.label
* @param {boolean} props.labelAfter - If true, label is placed after input (default before)
* @param {string} props.name
* @param {Object} props.value
* @param {Function} props.onBlur
* @param {Function} props.onChange
* @param {Function} props.onFocus
* @param {string} props.placeholder
* @param {string} props.size - "sm", "md", "lg"
* @returns {Object}
*/
export function PhoneInput(props) {
	const {
		id,
		error,
		disabled,
		isFocused,
		isVisible,
		label,
		labelAfter,
		name,
		value,
		onBlur,
		onChange,
		onFocus,
		placeholder,
		size,
	} = props;

	const hasValue = value && (value.length > 0);
	const inputType = "phone";

	return (
		<FieldControl
			disabled={disabled}
			error={error}
			hasValue={hasValue}
			isFocused={isFocused}
			id={id}
			inputType={inputType}
			isVisible={isVisible}
			label={label}
			labelAfter={labelAfter}
			size={size}
		>
			<PatternFormat
				format="###-###-####"
				customInput={CustomTextInput}
				id={id}
				name={name}
				type={inputType}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
				value={value}
				mask="_"
				placeholder={placeholder}
			/>
		</FieldControl>
	);
}
